import request from '@/services/api';

//订单主
// 创建订单接口
export function createOrder(data: {
  userId: number,
  receiverName: string,
  receiverPhone: string,
  receiverProvince?: string,
  receiverCity?: string,
  receiverDistrict?: string,
  receiverAddress: string,
  receiverPostalCode?: string,
  orderRemark?: string,
  orderSource?: number,
  payType: number,
  shippingType: number,
  uuid?: string,
  shopOrderList: Array<{
    shopId: number,
    totalAmount: number,
    payAmount: number,
    couponAmount?: number,
    taxAmount: number,
    shippingFee: number,
    orderItemList?: Array<{
      productId: number,
      skuId: number,
      productName: string,
      skuName?: string,
      skuCode?: string,
      specValues?: string,
      attrValues?: string,
      productSnapshot?: string,
      unit?: string,
      price: number,
      quantity: number,
      totalPrice: number,
      discountAmount?: number,
      isVirtual: number
    }>
  }>
}) {
  return request({
    url: '/order/createOrder',
    method: 'post',
    data
  })
}


// 获取订单详情接口
export function getOrderDetail(id: number) {
  return request({
    url: '/order/' + id,
    method: 'get'
  })
}

//获取备货凭据接口
export function getDeliveryList(id: number) {
  return request({
    url: '/order/voucher/' + id,
    method: 'get'
  })
}


// 获取订单列表接口
export function getOrderList(query: Record<string, unknown>) {
  return request({
    url: '/order/list',
    method: 'post',
    data: query
  })
}
//获取待支付订单
export function getWaitPayOrderList() {
  return request({
    url: '/payOrder/pending',
    method: 'get',
  })
}
//重新获取stripe支付信息
export function getStripeInfo(query: Record<string, unknown>) {
  return request({
    url: '/stripe/reuse-payment-intent',
    method: 'post',
    data:query
  })
}

//退货接口
export function returnOrder(query: Record<string, unknown>) {
  return request({
    url: '/order/requestRefund',
    method: 'post',
    data:query
  })
}
//提交退货凭证
export function submitReturnInfo(query: Record<string, unknown>) {
  return request({
    url: '/order/submitReturnInfo',
    method: 'post',
    data:query
  })
}

//购物车管理

// 修改购物车接口
export function editShoppingCart(data: {
  id?: number,
  shopId?: number,
  productId?: number,
  skuId?: number,
  quantity?: number,
  price?: number,
  checked?: number
}) {
  return request({
    url: '/shoppingCart/edit',
    method: 'put',
    data
  })
}

// 获取购物车列表接口
export function getShoppingCartList(data: {
  shopId?: number,
  productId?: number,
  checked?: number,
  pageNum?: number,
  pageSize?: number
}) {
  return request({
    url: '/shoppingCart/list',
    method: 'post',
    data:data
  })
}

// 获取购物车分页列表接口
export function getShoppingCartPageList(data: {
  shopId?: number,
  productId?: number,
  checked?: number,
  pageNum?: number,
  pageSize?: number
}) {
  return request({
    url: '/shoppingCart/listPage',
    method: 'post',
    data
  })
}

// 添加购物车接口
export function addShoppingCart(data: {
  shopId?: number,
  productId?: number,
  skuId?: number,
  quantity?: number,
  price?: number,
  checked?: number
}) {
  return request({
    url: '/shoppingCart/add',
    method: 'post',
    data
  })
}

// 获取购物车信息接口
export function getShoppingCartInfo(id: number) {
  return request({
    url: `/shoppingCart/getShoppingCartInfo/${id}`,
    method: 'get'
  })
}

// 删除购物车接口
export function deleteShoppingCart(ids: number[]) {
  return request({
    url: '/shoppingCart/delete',
    method: 'delete',
    data:ids 
  })
}


// 清空当前用户购物车接口
export function clearShoppingCart() {
  return request({
    url: '/shoppingCart/clear',
    method: 'delete',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}

//满减免配送费接口
export function getFullReductionShippingFee(configKey: string) {
  return request({
    url: 'config/configKey/'+configKey,
    method: 'get',
  })
}

//撰写评论接口
export function writeReview(query: Record<string, unknown>) {
  return request({
    url: '/product/review/add',
    method: 'post',
    data:query
  })
}






